import { PlayDemoBottomNavBtn } from "./play-demo-bottom-nav.models";

export const PLAY_BTN_CONFIG: PlayDemoBottomNavBtn = {
    redirectUrl: 'login', // redirect to login page when user is logged out, this is as all other casinos
    styles: 'btn btn-primary btn-lg mr-3'
}
